import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ImageCroppedEvent, base64ToFile } from 'ngx-image-cropper';
import { GalleryModalService } from '../gallery-modal/gallery-modal.service';
import { AuthServiceLocal } from '../services/auth.service';

@Component({
  selector: 'vex-cropper',
  templateUrl: './cropper.component.html',
  styleUrls: ['./cropper.component.scss']
})
export class CropperComponent implements OnInit {
  fileName;
  imageChangedEvent: any = '';
  imageFileToCrop;
  croppedImageBase64: any = '';
  croppedImageFile;
  sliderVal
  isVisible: boolean = false;
  ratio = 1 / 1;
  imageType: string;
  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<CropperComponent>,
    private auth: AuthServiceLocal,
    private imageUpload :GalleryModalService
  ) {
    if (this.data.imageEventToCrop) {
      this.imageChangedEvent = this.data.imageEventToCrop;
      this.fileName = this.data.imageEventToCrop.target.files[0].name
    }

    if (this.data.imageFile) {
      this.imageFileToCrop = this.data.imageFile
      this.fileName = this.data.imageFile.name
    }


    this.ratio = this.data.ratio


  }


  imageCropped(event: ImageCroppedEvent) {
    this.croppedImageBase64 = event.base64;
console.log(this.croppedImageBase64)
    let imageBlob = base64ToFile(event.base64)

    this.croppedImageFile = new File([imageBlob], this.fileName)
  }

  // imageLoaded(image: HTMLImageElement) {
  //   // show cropper
  // }

  cropperReady() {
    // cropper ready
  }

  loadImageFailed() {
    // show message
  }

  ngOnInit() {
  }

  public blobToFile = (theBlob: Blob, fileName: string): File => {
    var b: any = theBlob;
    //A Blob() is almost a File() - it's just missing the two properties below which we will add
    b.lastModifiedDate = new Date();
    b.name = fileName;

    //Cast to a File() type
    return <File>theBlob;
  }

  onCropClick(): void {
    this.isVisible = true
    
    console.log("this.data.type",this.data.type)
    if(this.data.type == 'wellnessImage'){
      this.imageType = 'wellnessImage'
    }else if(this.data.type == 'photo'){
      this.imageType = 'coverImage'
    }
    const FromData = new FormData();
            FromData.append('image', this.croppedImageFile);
            FromData.append('type', 'coverImage');
            this.auth.UploadImage(FromData).subscribe((response: any) => {
                if (response.status === 200) {
                    this.imageUpload.uploadedImage.next(response.data.imagePath)                  
                    console.log("hello there ",  );
                    
                    this.dialogRef.close({ croppedImageBase64: this.croppedImageBase64, croppedImageFile: this.croppedImageFile });
                }
            })
    
  }
}
